// A line ocs-capture could not place (a system notice, a rate-limit event, a block of a kind the
// view does not know) as text a person reads, not JSON (S157): its message when it has one, else
// one "Field: value" line per field, nested fields as "Parent › field". Identifiers the CLI adds
// to every line (session, uuid, parent tool) are left out.

const SKIP = new Set(["type", "subtype", "session_id", "uuid", "parent_tool_use_id", "signature"]);
/** Fields whose string value is the whole point of the line. */
const MESSAGE_KEYS = ["message", "text", "content", "summary", "description", "result", "status"];
const MAX_LINES = 40;
const MAX_DEPTH = 3;

const label = (key: string): string => {
  const words = key.replace(/([a-z])([A-Z])/g, "$1 $2").replaceAll("_", " ").trim();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

function scalar(v: unknown): string | undefined {
  if (typeof v === "string") return v;
  if (typeof v === "number" || typeof v === "boolean") return String(v);
  return undefined;
}

function fields(o: Record<string, unknown>, prefix: string, depth: number, out: string[]): void {
  for (const [key, v] of Object.entries(o)) {
    if (out.length >= MAX_LINES) return;
    if (SKIP.has(key) || v === null || v === undefined || v === "") continue;
    const name = prefix ? `${prefix} › ${label(key)}` : label(key);
    const s = scalar(v);
    if (s !== undefined) {
      out.push(`${name}: ${s}`);
    } else if (Array.isArray(v)) {
      const scalars = v.map(scalar);
      if (scalars.every((x) => x !== undefined)) {
        if (v.length > 0) out.push(`${name}: ${scalars.join(", ")}`);
      } else if (depth < MAX_DEPTH) {
        v.forEach((item, i) => {
          if (item && typeof item === "object") fields(item as Record<string, unknown>, `${name} ${i + 1}`, depth + 1, out);
        });
      }
    } else if (typeof v === "object" && depth < MAX_DEPTH) {
      fields(v as Record<string, unknown>, name, depth + 1, out);
    }
  }
}

/** The readable body of a JSON object a line carried. */
export function readableObject(o: Record<string, unknown>): string {
  for (const key of MESSAGE_KEYS) {
    const v = o[key];
    if (typeof v === "string" && v.trim() !== "") return v;
  }
  const out: string[] = [];
  fields(o, "", 0, out);
  return out.join("\n");
}
